import React from "react"


export default function EmptyContainer({ text = "Record not found", classes = "" }) {
    return <p className={`w-100 d-flex justify-content-center py-5 ${classes}`}>{text}</p>;
};